module.exports = __webpack_public_path__ + "img/icon-ecosystem.37026758.svg";